import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { getFechaFormatoSmall } from '../../Services/FechasService';
import { fromNow } from '../../Services/Moment/MomentService';

const TimeLineItem = ({
    index,
    dividerPosition,
    totalWidth,
    Item,
    dayWidth,
    startDate,
    child,
    showAllChildren,
    getDetails = () => { },
    bodyItemContent = false,
    titleItem = false,
    childBodyItemContent = false,
    childTitleItem = false,
    goToDate = () => { },
}) => {


    const [showChildren, setShowChildren] = useState(false);
    const [details, setDetails] = useState([]);
    const [loading, setLoading] = useState(false);


    const milisecondsInADay = 1000 * 60 * 60 * 24;

    // console.log({start: Item.startTime, ebnd: startDate.getTime()} );
    // console.log(new Date(Item.startTime), new Date(startDate.getTime()));
    
    // Calcular posición y ancho del item principal
    let width = Item.noDays * dayWidth;
    let start = (((Item.startTime - startDate.getTime()) / milisecondsInADay ) ) * dayWidth;
    const status = (new Date() > new Date(new Date(Item.endTime+ milisecondsInADay)) ? 'pastDue' : 'onTime')


    const openChildren = () => {
        // console.log('openChildren');
        goToDate(Item.startTime);
        if (!child) {
            if (details.length > 0) {
                setDetails([]);
            }
            else {
                setLoading(true);
                getDetails(Item?.IdSalesOrder, setDetails)
                    .then(() => {
                        setLoading(false);
                    })
                    .catch(() => {
                        setLoading(false);
                    });
            }
        }
    }

    useEffect(() => {
        if (showAllChildren) {
            getDetails(Item?.IdSalesOrder, setDetails)
        } else {
            setDetails([]);
        }
    }, [showAllChildren])


    return (
        <div key={index} className={'Timeline-Item ' + (child ? 'Timeline-Item-Child ' : ' ') + (details.length > 0 ? 'showChildren ' : ' ')} >
            {/* Título del Item principal */}
            <div className='rowTimeLine'>
                <div className='d-flex rowTimeLineTitle'>
                    <span onClick={openChildren}
                        className="Timeline-Item-Title"
                        style={{ width: dividerPosition }}
                    >
                        {/* {!child && <div className='Timeline-Item-Title-Icon'>
                        <Button
                            // icon={showChildren ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
                            className="p-button-text"
                            onClick={openChildren}
                            style={{ width: '2rem', height: '2rem', padding: 0, borderRadius: '50%' }}
                            color='Primary'
                        >
                            <i className={showAllChildren ? 'pi pi-chevron-up' : 'pi pi-chevron-down'} style={{ fontSize: '1.5rem' }}></i>
                        </Button>
                    </div>} */}
                        {titleItem ? titleItem(Item) :<div className='nowrap '>{Item.Title}</div>}
                        {Item?.ContentNumber && <div className='nowrap content'>( {Item.ContentNumber} )</div>}
                    </span>

                    <div className={'Timeline-Item-Body ' + status} style={{ width: totalWidth }}>
                        {/* FECHA DE INICIO */}
                        <div className='Timeline-Item-Body-Start' style={{ left: start - 130 }}>
                            <div className='Timeline-Item-Body-Start-Date'>
                                {getFechaFormatoSmall(new Date(Item?.startTime))}
                            </div>
                        </div>
                        {/* Cuerpo del Item principal */}
                        <div
                            className={'Timeline-Item-Body-Content '}

                            style={{
                                width: width,
                                left: start,
                            }}
                        >
                            <div onClick={openChildren} className='col-12' style={{ height: '100%' }} >
                                {bodyItemContent ? bodyItemContent(Item) : <span text>
                                    <div className='Timeline-Item-Body-Content-Title' style={{ display: 'flex', height: '100%' }}>
                                        <div className='col-12 nowrap'>{Item.TitleBar ? Item.TitleBar: Item.Title}</div>
                                    </div>
                                </span>
                                }
                            </div>
                        </div>

                        {/* FECHA DE FIN */}
                        <div className='Timeline-Item-Body-End' style={{ left: start + width + 10 }}>
                            <div className='Timeline-Item-Body-End-Date'>
                                {getFechaFormatoSmall(new Date(Item.endTime))}
                                {<div className={'text-hover ' + status}>
                                    {' '} - {fromNow(new Date(Item.endTime))}
                                    {/* <i className="pi pi-exclamation-triangle" style={{ color: 'red', fontSize: '1.5rem' }}></i> */}
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Cuerpo del Item principal */}

                {/* Renderizar hijos */}

                <div className="Timeline-Item-ChildrenContainer">
                    {details?.length > 0 && (
                        details.map((child, childIndex) => (
                            <TimeLineItem
                                key={`${index}-${childIndex}`}
                                index={childIndex}
                                dividerPosition={dividerPosition}
                                totalWidth={totalWidth}
                                Item={child}
                                dayWidth={dayWidth}
                                startDate={startDate}
                                child={true}
                                bodyItemContent={childBodyItemContent}
                                titleItem={childTitleItem}
                            />
                        ))
                    )}
                </div>


                {/* {Item.children?.length && showChildren > 0 && (
                <div className="Timeline-Item-ChildrenContainer">
                    {Item.children.map((child, childIndex) => (
                        <TimeLineItem
                            key={`${index}-${childIndex}`}
                            index={childIndex}
                            dividerPosition={dividerPosition}
                            totalWidth={totalWidth}
                            Item={child}
                            dayWidth={dayWidth}
                            startDate={startDate}
                            child={true}
                        />
                    ))}
                </div>
            )} */}
            </div>
        </div>
    );
};

export default TimeLineItem;